var map = {
	"./project_1.jpg": "NRk9",
	"./project_1_cut.jpg": "ty2P",
	"./project_1_gal_1.jpg": "AcZC",
	"./project_1_old.jpg": "o7ru",
	"./project_2.jpg": "pCnX",
	"./project_3.jpg": "hZ5G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/zTL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects ^\.\/.*$
// module id = /zTL
// module chunks = 0